import { render } from "./paragraph.vue?vue&type=template&id=ac4d7510"
import script from "./paragraph.vue?vue&type=script&lang=js"
export * from "./paragraph.vue?vue&type=script&lang=js"

import "./paragraph.vue?vue&type=style&index=0&id=ac4d7510&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/text/paragraph.vue'],['render',render],['__file',"paragraph.vue"]])

export default __exports__